















import { Vue, Component, Prop } from "vue-property-decorator";
import tinycolor from "tinycolor2";

@Component({})
export default class ColorPicker extends Vue {
  @Prop({ default: "#0057EA" }) defaultColor: string;
  color = "#000000";

  created() {
    this.color = this.defaultColor;
  }

  validateColor(event) {
    const color = tinycolor(event.target.value);
    if (color.isValid()) {
      this.color = color.toHexString();
      this.$emit("onColorUpdated", this.color);
    } else {
      this.color = "#000000";
      this.$emit("onColorUpdated", this.color);
    }
  }
}
